import React, { useState, useEffect } from "react";
import { useHistory } from 'react-router-dom';
import { getLanguage } from 'react-switch-lang';
import en from './en.json';
import ma from './ma.json';
import "./Mind.css";
import appointmentIcon from "./assets/Garbh Samarthya/vectors-02.png";
import mindImg from "./assets/home_icons/Image.png";
import mindIcon1 from "./assets/home_icons/Home Page_website-15.png";
import mindIcon2 from "./assets/home_icons/Home Page_website-16.png";
import mindIcon3 from "./assets/home_icons/Home Page_website-19.png";

// const translationData = { en: en, mr: ma };
const translationData = { en: en, ma: ma };

// const Mind = React.memo(() => {
  const Mind = () => {
  const history = useHistory();
  const [language, setLanguage] = useState(() => getLanguage() || 'en');

  // const t = (key) => {
  //   const langKey = language === 'ma' || language === 'mr' ? 'mr' : 'en';
  //   return translationData[langKey]?.[key] || '';
  // };

  const t = (key) => {
    const langKey = language === 'ma' ? 'ma' : 'en';
    return translationData[langKey]?.[key] || '';
  };

  useEffect(() => {
    const checkLang = () => {
      const current = getLanguage() || 'en';
      setLanguage(prev => prev !== current ? current : prev);
    };
    checkLang();
    const interval = setInterval(checkLang, 300);
    window.addEventListener('storage', checkLang);
    return () => {
       clearInterval(interval);
      window.removeEventListener('storage', checkLang);
    };
  }, []);

  return (
    <section className="mind-section">
      <div className="mind-container">

        {/* LEFT IMAGE */}
        <div className="mind-left">
          <img src={"https://res.cloudinary.com/dtuy184dc/image/upload/v1775113327/Imag_hftabx.jpg"} alt="Scientific Mind Assessment" />
        </div>

        {/* RIGHT CONTENT */}
        <div className="mind-right">
          {/* HEADING SECTION - Mobile: shows first */}
          <div className="mind-heading">
            <p className="mind-eyebrow">{t('mind_eyebrow')}</p>
            <h2 className="mind-title">
              {t('mind_main_title')}
            </h2>
          </div>

          {/* BULLETS SECTION - Mobile: shows after image */}
          <div className="mind-list">
            <div className="mind-item">
              <div className="mind-icon-wrapper">
                <img src={mindIcon1} alt="" />
              </div>
              <p>{t('mind_item1')}</p>
            </div>

            <div className="mind-item">
              <div className="mind-icon-wrapper">
                <img src={mindIcon2} alt="" style={{ marginRight: "10px" }} />
              </div>
              <p>{t('mind_item2')}</p>
            </div>

            <div className="mind-item">
              <div className="mind-icon-wrapper">
                <img src={mindIcon3} alt="" />
              </div>
              <p>{t('mind_item3')}</p>
            </div>
          </div>

          <div className="mind-buttons">
            <button
              type="button"
              className="mind-btn primary"
              onClick={() => window.open('https://onlineselftests.manashakti.org/', '_blank')}
            >
              {t('mind_btn_online')}
            </button>

            <button
              type="button"
              className="mind-btn outline"
              onClick={() => history.push('/booknow/Machine Tests/3')}
            >
              {t('mind_btn_appointment')}
              <img src={appointmentIcon} alt="Book appointment" className="mind-calendar" />
            </button>
          </div>

        </div>
      </div>
    </section>
  );
};

Mind.displayName = 'Mind';

export default Mind;